/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { DateValue, useModal } from '@jutro/components';
import { JobService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
import { platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { MLModalService } from 'ml-portals-services-react';
import { MLTagManagerService } from 'ml-portals-services-react'
import appConfig from 'app-config';
import metadata from './MLAccountPendingPolicyChangesComponent.metadata.json5';
import messages from './MLAccountPendingPolicyChangesComponent.messages';
import styles from './MLAccountPendingPolicyChangesComponent.module.scss';

import confirmWithdrawPopup from './ConfirmWithdrawPopup.metadata.json5';

import { Link } from '@jutro/router';

import { Icon } from '@jutro/legacy/components';

const INITIAL_MAX_PEDING_POLICY_CHANGES = 8;

const MLAccountPendingPolicyChangesComponent = (props) => {
    const modalApi = useModal();
    const { 
        pendingPolicyChanges,
        updatePendingPolicyChanges,
        accountNumber,
        history,
        displayPolicyNumberColumn
    } = props;

    const translator = useTranslator();
    const { authHeader } = useAuthentication();

    const {
        showProgressDialog,
        showErrorModal
    } = MLModalService();

    const [maxPendingPolicyChanges, setMaxPendingPolicyChanges] = useState(INITIAL_MAX_PEDING_POLICY_CHANGES);

    const loadPendingPolicyChangesForAccount = () => {
        const accountPromise = AccountService.getPendingPolicyChangesForAccount(accountNumber, authHeader);
        showProgressDialog(messages.loadingPendingPolicyChanges, accountPromise);
        accountPromise.then((results) => {
            updatePendingPolicyChanges(results);
        }, () => {
            showErrorModal(platformMessages.error, messages.loadPendingFailMsg);
        });
    };

    const withdrawPendingPolicyChange = (jobNumber) => {
        MLTagManagerService.sendLinkClickEvent(`Account Summary_deletePolicyChange`);
        const componentProps = {
            title: messages.withdrawPendingPopupTitle,
            uiProps: confirmWithdrawPopup.pageContent,
            actionBtnLabel: platformMessages.mlDelete,
            cancelBtnLabel: platformMessages.mlCancel,
            onSaveAction: () => {
                const jobPromise = JobService.withdrawJobByJobNumber(jobNumber, authHeader);
                showProgressDialog(messages.deletingChange, jobPromise);
                jobPromise.then(() => {
                    loadPendingPolicyChangesForAccount();
                }, () => {
                    showErrorModal(platformMessages.error, messages.withdrawPendingFailMsg);
                });
                return true;
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const startPolicyChange = (policyChange) => {
        // MLNavigationStepsTrackingService.init('PolicyChange');
        const policyNumber = policyChange.policyNumber;
        const { lobEndorsementURL, endorsementProducts } = appConfig;
        const productCode = _.get(policyChange, 'product.productCode');
        if (endorsementProducts.includes(productCode)) {
            showProgressDialog(platformMessages.loadingPolicyChange);
            history.push(lobEndorsementURL[productCode], { policyNumber });
        }
    };

    const getPolicyChangesTableOverrides = () => {
        const getEmptyDescription = () => {
            return translator(messages.noPendingPolicyChangesFound)
        }

        const getCreateTime = (policyChange) => {
            return <DateValue value={policyChange.createTime} displayFormat="vshort" />;
        };
        
        const getPolicyNumber = (policyChange) => {
            return <Link mlTagManagerLinkClick="Account Summary_Acount Details_Pending Changes_Policy" to={`/policies/${policyChange.policyNumber}/summary`}>{policyChange.policyNumber}</Link>;
        };

        const getDescription = (policyChange) => {
            return policyChange.description ? policyChange.description: '-'
        };

        const getStatus = (policyChange) => {
            return _.get(policyChange, 'status', '-');
        };

        const getWithdrawButton = (policyChange) => {
            return <div>
                <Link onClick={() => withdrawPendingPolicyChange(policyChange.jobNumber)} title="Delete Change" style={{'vertical-align': 'middle'}}><Icon icon="mi-delete" /></Link>
                <Link onClick={() => startPolicyChange(policyChange)} style={{ padding: '0 0 0 30px'}}><span style={{ 'text-transform': 'none'}}>Continue change</span></Link>
                </div>
        };

        const overrides = {
            policyChangesTable: {
                data: !_.isEmpty(pendingPolicyChanges)
                    ? _.take(_.orderBy(pendingPolicyChanges, ['createTime'], ['asc']), maxPendingPolicyChanges)
                    : [{}],
                visible: !_.isEmpty(pendingPolicyChanges)
            },
            createTimeColumn: {
                renderCell: !_.isEmpty(pendingPolicyChanges) ? getCreateTime : getEmptyDescription,
                renderHeader: () => {
                    return (
                        <>
                            <span>
                                { translator(messages.transactionDate) }
                            </span>
                            <Icon icon="mi-arrow-drop-down" style={{position: 'absolute', color: '#1fa5b7'}}/>
                        </>
                    )
                }
            },
            policyNumberColumn: {
                renderCell: !_.isEmpty(pendingPolicyChanges) ? getPolicyNumber : undefined,
                renderHeader: () => {
                    return translator(messages.policyNum);
                },
                visible: displayPolicyNumberColumn
            },
            descriptionColumn: {
                renderCell: !_.isEmpty(pendingPolicyChanges) ? getDescription : undefined,
                renderHeader: () => {
                    return translator(messages.description);
                }
            },
            statusColumn: {
                renderCell: !_.isEmpty(pendingPolicyChanges) ? getStatus : undefined,
                renderHeader: () => {
                    return translator(messages.jobStatus);
                }
            },
            withdrawPendingPolicyChangeColumn: {
                renderCell: !_.isEmpty(pendingPolicyChanges) ? getWithdrawButton : undefined,
                renderHeader: () => {
                    return translator(messages.actions);
                }
            }
        };

        return overrides;
    };

    const toggleMaxPendingPolicyChanges = () => {
        if (maxPendingPolicyChanges === INITIAL_MAX_PEDING_POLICY_CHANGES) {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Pending Changes_Expand`);
            setMaxPendingPolicyChanges(pendingPolicyChanges.length);
        } else {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Pending Changes_Collapse`);
            setMaxPendingPolicyChanges(INITIAL_MAX_PEDING_POLICY_CHANGES);
        }
    };

    const getToggleButtonDisplayName = () => {
        if (maxPendingPolicyChanges === INITIAL_MAX_PEDING_POLICY_CHANGES) {
            return translator(messages.expand);
        }

        return translator(messages.collapse);
    };

    const canTogglePendingPolicyChangesLength = () => {
        return pendingPolicyChanges && pendingPolicyChanges.length > INITIAL_MAX_PEDING_POLICY_CHANGES;
    };

    const overrideProps = {
        ...getPolicyChangesTableOverrides(),
        toggleMaxPendingPolicyChangesButton: {
            visible: canTogglePendingPolicyChangesLength(),
            content: getToggleButtonDisplayName(),
            onClick: toggleMaxPendingPolicyChanges
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
        />    
    )
};

MLAccountPendingPolicyChangesComponent.propTypes = {
    pendingPolicyChanges: PropTypes.arrayOf(PropTypes.shape({})),
    history: PropTypes.shape({push: PropTypes.func}).isRequired,
    displayPolicyNumberColumn: PropTypes.bool
};

MLAccountPendingPolicyChangesComponent.defaultProps = {
    pendingPolicyChanges: [],
    displayPolicyNumberColumn: true
};

export default withRouter(MLAccountPendingPolicyChangesComponent);